module.exports = new __parcel__URL__("dispel.7571e580.png").toString();